// extracted by mini-css-extract-plugin
export default {"container":"CopySettingsModal_container__r2N0Y","header":"CopySettingsModal_header__Cx231","text":"CopySettingsModal_text__890J2","buttons":"CopySettingsModal_buttons__nSIrY"};